import React, { useEffect, useRef, useState } from "react";
import ReusableDataTable from "../../Component/DataTable/ReusableDataTablePrime";
import { Autocomplete, Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton, Popover, TextField, Typography } from "@mui/material";
import { OverlayPanel } from "primereact/overlaypanel";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import { getStockColumn, getStockColumnn, getStockColumns, stockBodyTableIcon, stockCodeBodyTableIcon } from "../../const/StockData";
import { stockTypes } from "../../types/stockTypes";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { createStockData, deleteStockDetails, getListOfStock } from "../../api/Services/stockService";
import Swal from "sweetalert2";
import CreateStock from "../StockManagement/CreateStockInventory";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND } from "../../api/endpoint";
import FilterListIcon from '@mui/icons-material/FilterList';
import { getStockCodeButtonData, getStockSearchAndExportData } from "../../const/AssertData";
import { getCountryAssetMasterDataList, getLocalStoreByCountryId, getStockCodeMasterDataList, saveStockCode } from "../../api/Services/masterServie";
import { StockCodeMaster } from "../../types/assetTypes";
import { getAssertButtonData } from "../../const/AssertData";
import { getStockButtonData } from "../../const/AssertData";
import "xlsx-color";
import ImagePreview from "../../Component/ImagePreview";
import { handleLogisticsFilter, handleStockFilter } from "../../api/Services/assetServices";
import CreateStockCode from "../StockManagement/CreateStockCode";
import { RootState } from "../../store/Reduxstore";
import * as XLSX from "xlsx";


const StockInventory: React.FC = () => {
  const dt = useRef<DataTable<any[]>>(null);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState<stockTypes[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [stockCodeId, setStockCodeId] = useState<number | null>(null);
  const overlayPanelRef = useRef<OverlayPanel>(null);
  const [selectedValue, setSelectedValue] = useState<number | null>(null);
  const [paginationData, setPaginationData] = useState<{
    page: number;
    rows: number;
    totalRecords: number;
  }>({
    page: 1,
    rows: 10,
    totalRecords: 0,
  });



  const [countryName, setCountryName] = useState<
    { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (countryName.length === 0) getCountryNamesList(1, PAGESEND);
  }, [countryName]);



  const [localStore, setLocalStore] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const getCountryNamesList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getCountryAssetMasterDataList(page, rows, { currentLocationId: { value: "", matchMode: "startsWith" } });
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.currentLocationId.toString(),
          label: val.countryName,
        }));
        updatedData.unshift({ label: "Select Country", value: null });
        setCountryName(updatedData);

      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  const getLocalStoreList = async (currentLocationId: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getLocalStoreByCountryId(currentLocationId);

      if (status.code === 200 && data?.localStores?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.localStores.map(
          (val: { localStoreId: number; localStoreName: string }) => ({
            value: String(val.localStoreId), // Convert to string
            label: val.localStoreName ?? "", // Ensure it's a string
          })
        );

        setLocalStore(updatedData);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  //const [familyAsset, setFamilyAsset] = useState<assetFamilyMaster[]>([]);

  const onGlobalFilterChange = (e: { target: { value: any } }) => {
    console.log(e.target)

  };

  const exportCSV = (selectionOnly?: boolean) => {
    if (!dt.current) {
      alert("No data available to export.");
      return;
    }

    const data = dt.current.props.value || [];

    if (selectionOnly) {
      const selectedData = dt.current.props.selection || [];
      if (selectedData.length === 0) {
        alert("No rows selected for export.");
        return;
      }
      exportToExcel(selectedData);
    } else {
      exportToExcel(data);
    }
  };

  const exportToExcel = (data: any[]) => {
    if (!data || data.length === 0) {
      alert("No data to export.");
      return;
    }

    const XLSX = require("xlsx");

    const rows = data.map((row) => ({
      "Stock ID": row.stockId ?? "",
      "Stock Code": row.stockCodeId?.stockCode ?? "",
      "Description": row.description ?? "",
      "Current Stock": row.stockCodeId?.currentStock ?? "",
      "Rack Location": row.rackLocation ?? "",
      "Unit": row.unitId?.unitName ?? "",
      "Status": row.status ?? "",
      "Supplier": row.supplier ?? "",
      "Quantity": row.quantity ?? "",
      "Date": row.date ?? "",
      "PO Number": row.poNumber ?? "",
      "Local Store": row.localStoreId?.localStore ?? "",
      "Current Location": row.currentLocationId?.countryName ?? "",
      "Insurance Currency": row.insuranceCurrencyId?.insuranceCurrency ?? "",
      "Unit Value": row.insuranceCurrencyId?.unitValue ?? "",
      "Attachments": row.attachments?.attachmentId
        ? "Download Stock Image"
        : "No Attachment",
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const range = XLSX.utils.decode_range(worksheet["!ref"] || "");

    // Add hyperlinks for attachments
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const colIndex = Object.keys(rows[0]).indexOf("Attachments");
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: colIndex });

      if (worksheet[cellAddress] && worksheet[cellAddress].v.startsWith("Download")) {
        const attachmentId = data[R - 1]?.attachments?.attachmentId;
        if (attachmentId) {
          worksheet[cellAddress].l = {
            Target: FILE_DOWNLOAD_PREVIEW + attachmentId,
            Tooltip: "Click to download",
          };
        }
      }
    }

    // Set column widths
    worksheet["!cols"] = Object.keys(rows[0]).map(() => ({ wch: 20 }));

    // Create and save workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Data");
    XLSX.writeFile(workbook, "stock_data.xlsx");
  };

  const { inputField, headerButtons } = getStockSearchAndExportData(
    globalFilterValue,
    onGlobalFilterChange,
    exportCSV
  );

  const handleAddStock = async (newStockData: any) => {
    setLoading(true);
    try {
      const response = await saveStockCode(newStockData);
      let { status } = response;
      if (status.code === 200 || status.code === 201) {
        CustomMessage(status.message, "success", enqueueSnackbar);
        CustomMessage("StockCode added successfully", "success", enqueueSnackbar);
      } else {
        CustomMessage("Failed to add the stockcode.", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message || "Something went wrong!", "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };


  const handleDeleteAll = (selectionOnly: stockTypes[]) => {
    if (selectionOnly.length === 0) {
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this all!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        selectionOnly.map(async (val) => {
          try {
            dispatch(setLoading(true));
            const response = await deleteStockDetails(val?.stockId);
            if (response.status === 200) {
              onFetchData(paginationData.page, paginationData.rows, filterData);
              CustomMessage("Data deleted", "success", enqueueSnackbar);
            } else {
              CustomMessage(
                "Failed to delete the asset.",
                "error",
                enqueueSnackbar
              );
            }
          } catch (error: any) {
            CustomMessage(error?.message, 'error', enqueueSnackbar);
          } finally {
            dispatch(setLoading(false));
          }
        })
      }
    });
  }
  const handleClearFilter = () => {
    const clearedFilters: Filters = {
      countryId: { value: [] },
      localStoreId: { value: [] },
      currentLocationId: { value: [] },
    };

    // Reset dropdown states
    setSelectedCountryId(null);
    setSelectedLocalStore(null);

    // Reset filters
    setFilterData(clearedFilters);
    setSelectedValues([]);
    setSearchText("");
    setSubAnchorEl(null);
    setAnchorEl(null);

    // Reset local store options
    setLocalStore([{ label: "--Select--", value: null }]);

    // Fetch all data again with no filters
    onFetchData(paginationData.page, paginationData.rows, clearedFilters);
  };


  // const handleClearFilter = () => {
  //   // Clear filters and related UI states
  // setFilterData({});

  // setSelectedValues([]);

  // setSearchText("");
  // setSubAnchorEl(null); 
  // setAnchorEl(null);    
  // onFetchData(paginationData.page, paginationData.rows, {});
  // };  


  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [subAnchorEl, setSubAnchorEl] = useState<null | HTMLElement>(null);
  // const [filterCol, setFilterCol] = useState<string | null>(null);


  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  type Column = {
    key: string;
    label: string;
    values?: string[]; // Optional if values might not always exist
  };

  const openSubPopover = (
    event: React.MouseEvent<HTMLElement>,
    col: Column
  ) => {
    setSubAnchorEl(event.currentTarget);

    setSelectedValues(col.values || []);
  };

  const closeSubPopover = () => {
    setSubAnchorEl(null);

  };
  const [columnns, setColumns] = useState<{ key: string; label: string }[]>([]);

  const closeVisibilityPopover = () => {
    setAnchorEl(null);

    setSearchText(''); // clear search input
  };
  type Filters = {
    [key: string]: {
      value: string[]; // <- expects an array
    };
  };



  type AssetItem = {
    id: number;
    name: string;
  };
  const [searchText, setSearchText] = useState("");
  type AssetColumnData = {
    [key: string]: AssetItem[];
  };
  // const [filters, setFilters] = useState<Filters>({});







  const handleSubmit = (newFilters: Filters) => {
    console.log("Submitted Filters:", newFilters);
    setFilterData(newFilters);
    onFetchData(paginationData.page, paginationData.rows, newFilters);
    closeSubPopover();
    closeVisibilityPopover();
  };



  const handleCancel = () => {

    closeSubPopover();     // ✅ Close the popover
  };


  const userDetails = useSelector((state: RootState) => state.auth);

  const buttonData = getStockCodeButtonData(
    handleClearFilter,
    overlayPanelRef,
    exportCSV,                 // Pass export function in correct spot
    selectedProducts,
    () => setOpen(true),
    { role: userDetails.role.map(r => r.roleName) }
  );




  const handleSearch = () => {
    onFetchData(PAGESTART, PAGESEND, {}, searchText); // Call with search text
  };

  const [selectedCountryId, setSelectedCountryId] = useState<string | null>(null);
  const [selectedCountryName, setSelectedCountryName] = useState<string>("");
  const [selectedLocalStore, setSelectedLocalStore] = useState<string | null>(null);
  const [selectedLocalStoreName, setSelectedLocalStoreName] = useState<string>("");

  const renderHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column", // Stack vertically
          gap: "12px",
          width: "100%",
          padding: "8px",
        }}
      >
        {/* 🔼 Top: Country + Local Store */}
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          {/* Country Dropdown */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <select
              value={selectedCountryId ?? ""}
              // Country dropdown
              onChange={(e) => {
                const selectedId = e.target.value;
                const selectedCountry = countryName.find(c => c.value === selectedId);

                setSelectedCountryId(selectedId);
                setSelectedCountryName(selectedCountry?.label ?? "");

                let newFilters: Filters = {};
                if (selectedId) {
                  getLocalStoreList(Number(selectedId));
                  newFilters = {
                    ...filterData,
                    currentLocationId: { value: [selectedId] },
                  };
                  setFilterData(newFilters); // update parent filter state
                  onFetchData(PAGESTART, PAGESEND, newFilters); // fetch first page
                } else {
                  setLocalStore([{ label: "Select Localstore", value: null }]);
                  setSelectedLocalStore(null);
                  setFilterData({});
                  onFetchData(PAGESTART, PAGESEND, {}); // fetch first page with empty filter
                }
              }}

              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "180px",
              }}
            >
              <option value="" disabled>
                Select Country
              </option>
              {countryName.map((country) => (
                <option key={country.value} value={country.value ?? ""}>
                  {country.label}
                </option>
              ))}
            </select>
          </div>

          {/* Local Store Dropdown */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <select
              value={selectedLocalStore ?? ""}
              onChange={(e) => {
                const selectedStore = e.target.value;
                const storeObj = localStore.find(s => s.value === selectedStore);

                setSelectedLocalStore(selectedStore);
                setSelectedLocalStoreName(storeObj?.label ?? "");

                const newFilters: Filters = {
                  ...(selectedCountryId && { currentLocationId: { value: [selectedCountryId] } }),
                  localStoreId: { value: [selectedStore] },
                };

                setFilterData(newFilters);
                onFetchData(PAGESTART, PAGESEND, newFilters);
              }}

              disabled={!selectedCountryId}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "180px",
              }}
            >
              <option value="" disabled>
                Select Local Store
              </option>
              {localStore.map((store) => (
                <option key={store.value} value={store.value ?? ""}>
                  {store.label}
                </option>
              ))}
            </select>
          </div>


        </div>

        {/* 🔽 Bottom: Buttons + Search */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          {/* Left Side - Buttons */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {buttonData &&
              buttonData.map((val) => (
                <ReusablePrimeButton key={val.label} {...val} />
              ))}
          </div>

          {/* Right Side - Search Box */}
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search..."
              style={{
                padding: "6px 10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "220px",
              }}
            />
            <button
              onClick={handleSearch}
              style={{
                padding: "6px 12px",
                borderRadius: "4px",
                border: "none",
                backgroundColor: "#007bff",
                color: "white",
                cursor: "pointer",
              }}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    );
  };


  const handleDeleteStock = async (stockId: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await deleteStockDetails(stockId);
          if (response.status === 204) {
            onFetchData(paginationData.page, paginationData.rows);
            CustomMessage("Data deleted", "success", enqueueSnackbar);
          } else {
            CustomMessage(
              "Failed to delete the asset.",
              "error",
              enqueueSnackbar
            );
          }
        } catch (error: any) {
          CustomMessage(
            error?.message || "Something went wrong!",
            "error",
            enqueueSnackbar
          );
        } finally {
          setLoading(false);
        }
      } else {
        CustomMessage("Deletion cancelled", "info", enqueueSnackbar);
      }
    });
  };

  const onFetchData = async (page: number, rows: number, filter?: Filters, searchTerm: string = searchText) => {
    dispatch(setLoading(true));
    try {
      const response = await getListOfStock(page, rows, filter, searchTerm);
      const { data, status, pagination } = response;
      if (status.code === 200 && data != null && data?.length > 0) {
        setProducts(response.data);
        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setProducts([]);
        // CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleEditStockCode = (stockCodeId: number) => {
    setStockCodeId(stockCodeId);
    setOpen(true);
  };
  const actionBodyTemplate = (rowData: stockTypes) => {
    const renderIconData = stockCodeBodyTableIcon(
      handleEditStockCode,
      handleDeleteStock,
      rowData
    );
    return (
      <>
        {renderIconData &&
          renderIconData.map((val, index) => (
            <ReusablePrimeButton key={index} {...val} />
          ))}
      </>
    );
  };
  const ImageRendering = (rowData: any) => {
    const attachmentId = rowData.stockAttachmentId || 0; // Fallback image
    return (
      <div className="flex align-items-center gap-2">
        {
          (attachmentId != 0 && attachmentId != null) && (
            <ImagePreview
              src={`${FILE_DOWNLOAD_PREVIEW + attachmentId}`}
              alt={`Attachment ${attachmentId}`}
              style={{
                width: "19px",
                height: "19px",
                borderRadius: "50%",
                objectFit: "cover"
              }}
            />
          )
        }
        {/* <span>{attachmentId}</span> */}
      </div>
    );
  }
  const columns = getStockColumnn(actionBodyTemplate, ImageRendering);

  const [filterData, setFilterData] = useState<Record<string, any>>(() =>
    (columns ?? []).reduce((acc, col) => {
      if (col.field) {
        acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
      }
      return acc;
    }, {} as Record<string, { value: string; matchMode: string }>),
  );

  //onst userDetails = useSelector((state: RootState) => state.auth)
  const header = renderHeader();
  return (
    <div>
      <Box sx={{ mb: 2 }}>
        <h2 style={{ margin: "0 0 12px 8px", fontWeight: 500, fontSize: "18px" }}>
          Country View
        </h2>
      </Box>
      {!open ? (
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 3,
            boxShadow: 3,
            padding: 2, // Add padding for better spacing
          }}
        >
          <ReusableDataTable
            ref={dt}
            data={products} // Pass the data array
            columns={columns} // Pass the columns definition
            onFetchData={onFetchData} // Pass the function to fetch data
            emptyMessage="No data found."
            globalFilterFields={[
              "assetOwnerName",
              "harmonyCode",
              "codeType",
              "familyAsset",
            ]}
            header={header}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            selection={selectedProducts}
            selectionMode={"multiple"}
            //rowsPerPageOptions={[10, 25, 50, 70, 100]}
            //filters={filters}
            pagination={paginationData}
            setPagination={setPaginationData}
            onRowDoubleClick={(rowData) => {
              console.log('Double-click row:', rowData);
              handleEditStockCode(rowData.stockCodeId);
            }}
            filters={filterData}
            setFilters={setFilterData}

          />
        </Box>
      ) : (
        <CreateStockCode
          setStockCodeId={setStockCodeId}
          setOpen={setOpen}
          stockCodeId={stockCodeId}
          selectedCountryId={selectedCountryId}
          selectedLocalStoreId={selectedLocalStore}
          selectedCountryName={selectedCountryName}           // ✅ Add this
          selectedLocalStoreName={selectedLocalStoreName}     // ✅ And this
          getListOfSelectedProducts={() =>
            onFetchData(paginationData.page, paginationData.rows)
          }

        />


      )}
    </div>
  )
}

export default StockInventory;